import styles from './Features.module.css'

const features = [
  {
    title: 'Code Editor',
    description:
      'A JavaScript-based editor with syntax highlighting and autocomplete. And a vim-mode :)',
  },
  {
    title: 'Sprite Editor',
    description:
      'Create and edit pixel art sprites for your games with a familiar 16-color palette',
  },
  {
    title: 'Map Editor',
    description: 'Design and build tile-based levels and worlds for your games',
  },
  {
    title: 'Sound Editor',
    description: 'Create chiptune sound effects and music',
  },
  {
    title: 'Cloud Save',
    description: 'Save your work and access it anywhere',
  },
  {
    title: 'Share & Remix',
    description: "Share your games and remix others' creations",
  },
]

export function Features() {
  return (
    <section id='features' className={styles.section}>
      <div className={styles.inner}>
        <h2 className={styles.heading}>Features</h2>
        <div className={styles.grid}>
          {features.map((f) => (
            <div key={f.title} className={styles.card}>
              <h3 className={styles.cardTitle}>{f.title}</h3>
              <p className={styles.cardDesc}>{f.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
